// extracted by mini-css-extract-plugin
export default {"root":"ViewerTxt__root--SxYpd","root_embedded":"ViewerTxt__root_embedded--2QqJF","txt":"ViewerTxt__txt--2vvX6"};